class NssPDPCarousel extends HTMLElement {

    constructor() {
        super();

        this.debug = false;

        this.swiper;

        this.videoSlideEls = this.querySelectorAll(`[nss-video-playing]`);
    }

    connectedCallback() {
        if (this.debug) console.log("[NSS][Carousel] Connected.");

        this.initCarousel();

        this.addEventListener(`click`, (e) => {
            if (e.target.hasAttribute(`nss-video-playing`)) {
                if (e.target.getAttribute(`nss-video-playing`) === "false") {
                    this.stopAllVideos();
                    e.target.setAttribute(`nss-video-playing`, true);
                    const videoEl = e.target.querySelector(`video`);
                    videoEl.volume = 0.2;
                    videoEl.muted = false;
                    videoEl.play();
                } else {
                    this.stopAllVideos();
                }
            }
        });

        const editorEvents = [
            `shopify:inspector:activate`,
            `shopify:inspector:deactivate`,
            `shopify:section:load`,
            `shopify:section:unload`,
            `shopify:section:select`,
            `shopify:section:deselect`,
            `shopify:section:reorder`,
            `shopify:block:select`,
            `shopify:block:deselect`,
        ]
        editorEvents.forEach((event) => {
            this.addEventListener(event, this.handleEditorEvent.bind(this));
        });
    }

    stopAllVideos() {
        this.videoSlideEls.forEach((videoSlideEl) => {
            const videoEl = videoSlideEl.querySelector(`video`);
            videoEl.pause();
            videoEl.muted = true;
            videoSlideEl.setAttribute(`nss-video-playing`, false);
        });
    }

    initCarousel() {
        const carouselEl = this.querySelector(`.js-nss-swiper`);
        const carouselElThumbs =this.querySelector(`.js-nss-swiper-thumbs`);

const self =this;
        this.swiperThumbs = new Swiper(carouselElThumbs, {
            spaceBetween: 8,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesProgress: true,
            direction: "vertical",
            observer: true,
            observeParents: true
        });
        this.allSettings = {

            loop: false,
            centeredSlides: false,
            slidesPerView: "auto",
            spaceBetween: 12,
            direction: "horizontal",
            autoHeight: false,
            observer: true,
            observeParents: true,
            watchOverflow: true,

            a11y: {
                enabled: true,
            },
            navigation: {
                prevEl: '.nss-carousel-button-prev1',
                nextEl:'.nss-carousel-button-next1'
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets'
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: false
            },
            grabCursor: true,
            on: {
                slideChange(swiper) {
                    self.querySelectorAll('.js-progress').forEach(el => {
                        el.setAttribute('stroke-dasharray', '100 100');
                    });
                },
                autoplayTimeLeft(swiper, time, progress) {
                    const value = (1 - progress) * 100;

                    self.querySelectorAll('[aria-current="true"] .js-progress').forEach(el => {
                        el.setAttribute('stroke-dasharray', `${value} 100`);
                    });
                }
            },
            thumbs: {
                swiper: this.swiperThumbs,
            },

        }

        this.swiper = new Swiper(carouselEl, this.allSettings);


    }

    handleEditorEvent(e) {
        if (this.debug) console.log("[NSS][Carousel] Handle editor event, e:", e);

        switch (e.type) {

            case `shopify:block:select`:
                const blockEl = e.detail.blockId ? this.querySelector(`[data-block-id="${e.detail.blockId}"]`) : null;
                const slideEl = blockEl?.closest(`.swiper-slide`);
                if (this.debug) console.log("[NSS][Carousel] slideEl:", slideEl);
                if (slideEl) {
                    // const index = slideEl.getAttribute(`data-swiper-slide-index`);
                    const slideEls = [...this.querySelectorAll(`.swiper-slide`)];
                    const index = slideEls.indexOf(slideEl);
                    if (this.debug) console.log("[NSS][Carousel] Sliding to index:", index);
                    this.swiper.slideTo(index);
                }
                break;

        }
    }
}

let elementName = `nss-pdp-carousel`;
if (typeof customElements.get(elementName) === `undefined`) {
    customElements.define(elementName, NssPDPCarousel);
}